import React from "react";
import { ArrowRight, Linkedin, Phone, Mail } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useContactModal } from "../context/ContactModalContext";
import { useCookieConsent } from "../context/CookieConsentContext";
import SalesLogo from '../assets/Images/logo-sales.png';
import MedicalLogo from '../assets/Images/logo-medical.png';
export default function Footer() {
  const { openContactModal } = useContactModal() || {};
  const { openCookiePreferences } = useCookieConsent() || {};
  const location = useLocation();
  const isSales = location.pathname.startsWith("/sales");

  const linkBase =
    "text-[15px] text-neutral-900/80 hover:text-neutral-900 transition";

  const legalLink =
    "text-[12px] font-semibold tracking-wide text-neutral-900/80 hover:text-neutral-900 underline underline-offset-[6px] decoration-neutral-900/30 hover:decoration-neutral-900 transition";
  const legalBasePath = isSales ? "/sales" : "/medical";
  const CONTACT_LINKS = {
    linkedin: "https://www.linkedin.com/in/claudia-von-tein-1ba43868/",
    phone: "tel:06983835170",
    email: "mailto:info@repexo.de",
  };

  return (
    <footer className="bg-[#F3F1ED] text-neutral-900">
      <div className="mx-auto container-app pr-16 md:pr-20 lg:pr-24">
        {/* TOP GRID: sales has 3 link columns + assist → 5 cols with wider last; medical has 4 link cols + assist → 6 cols */}
        <div
          className={`grid grid-cols-1 gap-10 pt-14 ${isSales
              ? "lg:grid-cols-[1.35fr_1fr_1fr_1fr_2.4fr]"
              : "lg:grid-cols-[1.35fr_1fr_1fr_1fr_1.25fr_1.35fr]"
            }`}
        >

          {/* Left big statement */}
          <div>
            <h2 className="text-xl sm:text-3xl md:text-4xl font-semibold md:font-medium text-gray-900">
              {isSales ? (
                <>
                  REPEXO Sales
                  <br />
                  Headhunter für den Vertrieb
                </>
              ) : (
                <>
                 
                </>
              )}
            </h2>
          </div>

          {isSales ? (
            <>
              {/* Column 1: Unternehmen – sales site */}
              <div className="space-y-4 flex flex-col pt-1">
                <h4 className="text-[16px] font-semibold text-gray-900">Unternehmen</h4>
                <Link to="/sales/sales-klassisch" className={linkBase}>Vertrieb klassisch</Link>
                <Link to="/sales/sales-industrie" className={linkBase}>Industrie Sales</Link>
                <Link to="/sales/sales-healthcare" className={linkBase}>Healthcare Sales</Link>
                <Link to="/sales/referenzen" className={linkBase}>Referenzen</Link>
              </div>

              {/* Column 2: Ressourcen – sales site */}
              <div className="space-y-4 flex flex-col pt-1">
                <h4 className="text-[16px] font-semibold text-gray-900">Ressourcen</h4>
                <Link to="/sales/insights" className={linkBase}>Einblicke</Link>
              </div>

              {/* Column 3: Über uns – sales site */}
              <div className="space-y-4 flex flex-col pt-1">
                <h4 className="text-[16px] font-semibold text-gray-900">Über uns</h4>
                <Link to="/sales/geschichte" className={linkBase}>Unsere Geschichte</Link>
                <Link to="/sales/team" className={linkBase}>Team</Link>
                <Link to="/sales/awards" className={linkBase}>Auszeichnungen</Link>
              </div>
            </>
          ) : (
            <>
              {/* Column 1: Unternehmen – matches navbar (Für Unternehmen) */}
              <div className="space-y-4 flex flex-col pt-1">
                <h4 className="text-[16px] font-semibold text-gray-900">Unternehmen</h4>
                <Link to="/medical/executive-search" className={linkBase}>Executive Search</Link>
                <Link to="/medical/suchmethode" className={linkBase}>Suchmethode</Link>
                <Link to="/medical/praxisnachfolger-suche" className={linkBase}>Praxisnachfolger-Suche</Link>
                <Link to="/medical/referenzen" className={linkBase}>Referenzen</Link>
                <Link to="/medical/besetzte-positionen" className={linkBase}>Besetzte Positionen</Link>
                <Link to="/medical/garantien" className={linkBase}>Garantien</Link>
                <Link to="/medical/soziale-verantwortung" className={linkBase}>Soziale Verantwortung</Link>
                <Link to="/medical/rekrutierungsprozess" className={linkBase}>Rekrutierungsprozess</Link>
                <Link to="/medical/faq" className={linkBase}>FAQ</Link>
              </div>

              {/* Column 2: Kandidaten */}
              <div className="space-y-4 flex flex-col pt-1">
                <h4 className="text-[16px] font-semibold text-gray-900">Kandidaten</h4>
                <Link to="/medical/kandidatenreise" className={linkBase}>Kandidatenreise</Link>
                <Link to="/medical/karriere" className={linkBase}>Karriere</Link>
                <Link to="/medical/kandidatenfeedback" className={linkBase}>Kandidatenfeedback</Link>
                <Link to="/medical/faq-kandidaten" className={linkBase}>FAQ Kandidaten</Link>
              </div>

              {/* Column 3: Ressourcen */}
              <div className="space-y-4 flex flex-col pt-1">
                <h4 className="text-[16px] font-semibold text-gray-900">Ressourcen</h4>
                <Link to="/medical/insights" className={linkBase}>Einblicke</Link>
                <Link to="/medical/fallstudien" className={linkBase}>Fallstudien</Link>
              </div>

              {/* Column 4: Über uns – matches navbar */}
              <div className="space-y-4 flex flex-col pt-1">
                <h4 className="text-[16px] font-semibold text-gray-900">Über uns</h4>
                <Link to="/medical/geschichte" className={linkBase}>Geschichte</Link>
                <Link to="/medical/team" className={linkBase}>Team</Link>
                <Link to="/medical/besetzte-positionen" className={linkBase}>Besetzte Positionen</Link>
                <Link to="/medical/auszeichnungen" className={linkBase}>Auszeichnungen</Link>
              </div>
            </>
          )}

          {/* Assist block */}
          <div className="pt-1 lg:pl-6">
            <h3 className="text-[22px] font-semibold tracking-[-0.01em]">
              Wie können wir Ihnen helfen?
            </h3>

            <p className="mt-3 mb-6 max-w-[360px] text-[13px] leading-5 text-neutral-900/70">
              {isSales
                ? "Wir sind der festen Überzeugung, dass wir Ihnen mit unserer Vertriebsexpertise einen erheblichen Mehrwert zur weiteren Stärkung Ihres Vertriebes - auf allen Ebenen - bieten können. Denn die Erfahrung und die Branchenkenntnisse machen den Unterschied..."
                : "Wir freuen uns über die Möglichkeit, mit Ihnen in Kontakt zu treten. Bitte senden Sie uns Ihre Anfragen und Ihr Feedback. Unsere erfahrenen Experten stehen Ihnen gerne zur Verfügung."}
            </p>

            <button
              type="button"
              onClick={() => openContactModal?.()}
              className="group btn btn-bg mt-auto mt-4 text-gray-900"
            >
              Kontakt <ArrowRight className="h-5 w-6 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-0.5" aria-hidden />
            </button>
          </div>
        </div>

        {/* Big empty space */}
        <div className="h-16 sm:h-20 lg:h-28" />

        {/* BOTTOM ROW */}
        <div className="flex pb-8">

          {/* Logo */}
          <div className="flex items-end gap-4">
            <Link to="/">
            <img
              src={isSales ? SalesLogo : MedicalLogo}
              alt={isSales ? "REPEXO Sales Logo" : "REPEXO Medical Logo"}
              className="h-10 w-auto md:h-16"
            />
            </Link>
            
          </div>

        </div>

        {/* LEGAL LINKS (left) + ADDRESSES (right) */}
        <div className="flex flex-wrap items-start justify-between gap-x-8 gap-y-6 pb-10">
          <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
            <Link to={`${legalBasePath}/datenschutz`} className={legalLink}>DATENSCHUTZ</Link>
            <Link to={`${legalBasePath}/impressum`} className={legalLink}>IMPRESSUM</Link>
            <Link to={`${legalBasePath}/agb`} className={legalLink}>AGB</Link>
            <button type="button" onClick={() => openCookiePreferences?.()} className={legalLink}>COOKIE PREFERENCES</button>
          </div>
          <div className="shrink-0 text-left">
            <div className="grid grid-cols-[max-content_1fr] gap-x-4 gap-y-4 items-start">
              <span className="text-[12px] font-bold uppercase tracking-[0.14em] text-neutral-900/80">
                Folgen Sie uns
              </span>
              <div className="flex items-center gap-5 text-neutral-900">
                <a href={CONTACT_LINKS.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="hover:opacity-70 transition">
                  <Linkedin className="h-[18px] w-[18px]" />
                </a>
                <a
                  href={CONTACT_LINKS.phone}
                  aria-label="Anrufen"
                  title="069 / 83 83 517 - 0"
                  className="hover:opacity-70 transition"
                >
                  <Phone className="h-[18px] w-[18px]" />
                </a>
                <a
                  href={CONTACT_LINKS.email}
                  aria-label="E-Mail"
                  className="hover:opacity-70 transition"
                >
                  <Mail className="h-[18px] w-[18px]" />
                </a>
              </div>
              <span className="text-[12px] font-bold uppercase tracking-[0.14em] text-neutral-900/80">
                Zentrale:
              </span>
              <address className="not-italic min-w-0 text-[13px] font-normal leading-relaxed tracking-wide text-neutral-900/80 sm:text-sm">
                <span className="block">REPEXO GmbH &amp; Co. KG</span>
                <span className="block">Am Hauptbahnhof 16</span>
                <span className="block">60329 Frankfurt am Main</span>
              </address>
              <span className="text-[12px] font-bold uppercase tracking-[0.14em] text-neutral-900/80">
                Niederlassung Nord/Ost:
              </span>
              <address className="not-italic min-w-0 text-[13px] font-normal leading-relaxed tracking-wide text-neutral-900/80 sm:text-sm">
                <span className="block">REPEXO GmbH &amp; Co. KG</span>
                <span className="block">Technologiezentrum Olympiapark</span>
                <span className="block">26419 Schortens</span>
              </address>
            </div>
          </div>
        </div>

        {/* COPYRIGHT */}
        <div className="pb-12">
          <p className="text-[11px] leading-5 text-neutral-900/60">
            2026 © REPEXO GmbH & Co. KG. All rights reserved
          </p>
          <p className="mt-1 text-[12px] font-semibold leading-5 text-neutral-900/80">
            <a
              href="https://uneva.de"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-neutral-900 transition"
            >
              Entwickelt von uneva.de
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}